// extracted by mini-css-extract-plugin
module.exports = {"goodsAdress":"payMoeny_goodsAdress__3np0d","costTitle":"payMoeny_costTitle__3Ds1a","costM":"payMoeny_costM__MseGA","footBtn":"payMoeny_footBtn__2vusW"};